export default __webpack_public_path__ + "static/media/uniCampus3dgazebo-halfSized.5f1a3cbc.gif";